<template>
  <div id="contenedor-listado-contratos-minutas">
    <v-data-table
      :headers="headers"
      :items="listado"
      >
      <template v-slot:[`item.numero`]="{ item }">
        <b>
          {{ item.numero }}
        </b>
      </template>
      <template v-slot:[`item.fechaHora`]="{ item }">
        {{ new Date(item.fechaHora).toISOString().split('T')[0]}}
      </template>
      <template v-slot:[`item.participantes`]="{ item }">
        <v-chip @click="verParticipantes(item)" color="grey lighten-3">
          Ver
          <v-badge inline left
          :content="item.participantes.length || '0'"></v-badge>
        </v-chip>
      </template>
      <template v-slot:[`item.asuntos`]="{ item }">
        <v-chip @click="verAsunstos(item)" color="grey lighten-3">
          Ver
          <v-badge inline left :content="item.cantidadAsuntos || '0'"></v-badge>
        </v-chip>
      </template>
      <template v-slot:[`item.acuerdos`]="{ item }">
        <v-chip @click="verAcuerdos(item)" color="grey lighten-3">
          Ver
          <v-badge inline :content="item.acuerdos.length || '0'"></v-badge>
        </v-chip>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list nav>
            <v-list-item @click="botonEditarMinuta(item)">
              <v-list-item-icon>
                <v-icon>
                  mdi-pencil
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>Editar</v-list-item-title>
            </v-list-item>
            <v-list-item @click="botonEliminarMinuta(item)">
              <v-list-item-icon>
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>Borrar</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:[`item.generadorPlantilla`]="{item}">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
            <PdfMinuta
            :idMinuta="item.id"/>
            </div>
          </template>
          <span>Generar PDF</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <!-- Ventana Listado Participantes -->
    <v-dialog
    v-if="mostrarParticipantes"
    v-model="mostrarParticipantes"
    width="850"
    persistent>
    <ListadoParticipantes
    v-on:cerrar="mostrarParticipantes=!mostrarParticipantes"
    :minuta="estaMinuta"
    :participantesMinutasAnteriores="getParticipantesMinutasAnteriores"/>
  </v-dialog>
  <!-- Ventana Listado Acuerdos -->
  <v-dialog
    v-if="mostrarAcuerdos"
    v-model="mostrarAcuerdos"
    width="fullscreen"
    persistent>
    <ListadoAcuerdos
    v-on:cerrar="mostrarAcuerdos=!mostrarAcuerdos"
    :minuta="estaMinuta"/>
  </v-dialog>
  <!-- Ventana Editar Minuta -->
  <v-dialog
    v-if="mostrarEditarMinuta"
    v-model="mostrarEditarMinuta"
    width="600"
    persistent>
    <EditarMinuta
    v-on:cerrar="mostrarEditarMinuta=!mostrarEditarMinuta"
    :minutaEditar="estaMinuta"/>
  </v-dialog>
  <!-- Ventana Eliminar Minuta -->
  <v-dialog
    v-if="mostrarEliminarMinuta"
    v-model="mostrarEliminarMinuta"
    width="600"
    persistent>
    <EliminarMinuta
    v-on:cerrar="mostrarEliminarMinuta=!mostrarEliminarMinuta"
    :minutaEliminar="estaMinuta"/>
  </v-dialog>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import ListadoParticipantes from '@/components/administracion/minutas/participantes/listado.vue';
import ListadoAcuerdos from '@/components/administracion/minutas/acuerdos/listado.vue';
import EditarMinuta from '@/components/administracion/minutas/minuta/Editar.vue';
import EliminarMinuta from '@/components/administracion/minutas/minuta/Eliminar.vue';
import PdfMinuta from '@/components/administracion/minutas/minuta/pdfMinuta.vue';

export default {
  name: 'contratista-contratos-minutas-listado-desktop',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  components: {
    ListadoParticipantes,
    ListadoAcuerdos,
    EditarMinuta,
    EliminarMinuta,
    PdfMinuta,
  },
  data() {
    return {
      mostrarParticipantes: false,
      mostrarAcuerdos: false,
      mostrarEditarMinuta: false,
      mostrarEliminarMinuta: false,
      estaMinuta: {},
      headers: [
        {
          text: 'Número',
          sortable: false,
          value: 'numero',
        },
        { text: 'Fecha', value: 'fechaHora', sortable: false },
        { text: 'Lugar', value: 'lugar', sortable: false },
        { text: 'Objetivo', value: 'objetivo', sortable: false },
        {
          text: 'Participantes', value: 'participantes', align: 'center', sortable: false,
        },
        {
          text: 'Asuntos', value: 'asuntos', align: 'center', sortable: false,
        },
        {
          text: 'Acuerdos', value: 'acuerdos', align: 'center', sortable: false,
        },
        {
          text: '', value: 'generadorPlantilla', align: 'center', sortable: false,
        },
        {
          text: '',
          align: 'end',
          value: 'acciones',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    botonEditarMinuta(item) {
      this.estaMinuta = item;
      this.mostrarEditarMinuta = true;
    },
    botonEliminarMinuta(item) {
      this.estaMinuta = item;
      this.mostrarEliminarMinuta = true;
    },
    verParticipantes(item) {
      this.estaMinuta = item;
      this.mostrarParticipantes = true;
    },
    verAsunstos(minuta) {
      eventBus.$emit('ver-minuta-asuntos', minuta);
    },
    verAcuerdos(item) {
      this.estaMinuta = item;
      this.mostrarAcuerdos = true;
    },
    generarMinutaPdf(item) {
      this.estaMinuta = item;
      console.log('generarMinutaPdf', this.estaMinuta);
    },
  },
  computed: {
    getParticipantesMinutasAnteriores() {
      if (!this.listado) return [];
      const participantesUnicos = Array.from(
        new Map(
          this.listado
            .flatMap((minuta) => minuta.participantes)
            .map((participante) => [participante.nombre, participante]),

        ).values()
          .map((p) => ({
            idMinuta: this.estaMinuta.id,
            nombre: p.nombre,
            puesto: p.puesto,
            tipo: p.tipo,
          })),
      );
      return participantesUnicos;
    },
  },
};
</script>

<style lang="scss">

</style>
